import { render, staticRenderFns } from "./style-sidebar.vue?vue&type=template&id=6a66f2ea&scoped=true&"
import script from "./style-sidebar.vue?vue&type=script&lang=js&"
export * from "./style-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./style-sidebar.vue?vue&type=style&index=0&id=6a66f2ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66f2ea",
  null
  
)

export default component.exports